import { Box, Tab, Tabs } from "@mui/material";
import React, { useState } from "react";
import TemplateList from "./TemplateList";
import CreateEmailTemplate from "./CreateEmailTemplate";

function a11yProps(index: number) {
	return {
		id: `simple-tab-${index}`,
		"aria-controls": `simple-tabpanel-${index}`,
	};
}

interface TabPanelProps {
	children?: React.ReactNode;
	index: number;
	value: number;
}

interface ISelectedTemplateState {
	_id: string;
	name: string;
}

function CustomTabPanel(props: TabPanelProps) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

function EmailTemplate() {
	const [value, setValue] = useState(0);
	const [selectedTemplate, setSelectedTemplate] =
		useState<ISelectedTemplateState | null>(null);

	const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
		setValue(newValue);
	};
	return (
		<div>
			<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
				<Tabs
					value={value}
					onChange={handleChange}
					aria-label="basic tabs example"
				>
					<Tab label="Templates List" {...a11yProps(0)} />
					<Tab label="Create Template" {...a11yProps(1)} />
				</Tabs>
			</Box>

			<CustomTabPanel value={value} index={0}>
				<TemplateList
					value={selectedTemplate}
					onChange={(val: ISelectedTemplateState) =>
						setSelectedTemplate(val)
					}
				/>
			</CustomTabPanel>
			<CustomTabPanel value={value} index={1}>
				<CreateEmailTemplate />
			</CustomTabPanel>
		</div>
	);
}

export default EmailTemplate;
